// extracted by mini-css-extract-plugin
module.exports = {"postedBy":"e_vw","postedByDate":"e_ww","container":"e_xw","description":"e_yw","title":"e_zw"};